export const CLOSE_PASSENGERS_TO_BE_DELETED_CONFIRMATION =
  'CLOSE_PASSENGERS_TO_BE_DELETED_CONFIRMATION'

export default () => ({
  type: CLOSE_PASSENGERS_TO_BE_DELETED_CONFIRMATION,
})
